import React from 'react';
import { observer } from 'mobx-react-lite';
import { Redirect } from 'react-router-dom';

import { useStore } from '@src/models';

export const DefaultPrivateRoute = observer(function DefaultPrivateRoute() {
  const { userStore } = useStore();

  if (userStore.isEmployer) {
    // for employers this is full URL which react-router cannot handle
    window.location.replace(userStore.defaultPrivateRoute);
    return;
  }

  return <Redirect to={userStore.defaultPrivateRoute} />;
});
